/* "Build a run": a tiny marble-run game for the wooden track kit page.
   Tap a ramp to turn it (left, right, away), then drop a ball and steer it into the golden cup.
   No libraries. The physics engine is pure (no DOM) so it can be tested in Node. */
(function () {
  'use strict';

  var LANG = String((typeof document !== 'undefined' && document.documentElement.lang) || 'en').slice(0, 2).toLowerCase();
  var DICT = {
    ru: {
      'Round over: {pts} pts': 'Раунд окончен: {pts} очк.',
      'Ball {n} of {total} · {pts} pts': 'Шарик {n} из {total} · {pts} очк.',
      'Aim for cup {n} (the gold one).': 'Цельтесь в чашку {n} (золотую).',
      'Tap a ramp to turn it, then drop a ball.': 'Нажимайте на горки, чтобы повернуть их, и отпускайте шарик.',
      'Rolling…': 'Катится…',
      'Congratulations! Golden cup +5. The start and the golden cup have moved: {aim}': 'Поздравляем! Золотая чашка: +5. Старт и золотая чашка переехали: {aim}',
      'In cup {n}: +1. {aim}': 'В чашке {n}: +1. {aim}',
      'That one got stuck. Next ball.': 'Этот шарик застрял. Следующий!',
      'Round over: {pts} points. Best: {best}. Fancy another round?': 'Раунд окончен. Очки: {pts}. Рекорд: {best}. Сыграем ещё?',
      'START': 'СТАРТ',
      'Congratulations!': 'Поздравляем!',
      'Golden cup! +5': 'Золотая чашка! +5'
    },
    de: {
      'Round over: {pts} pts': 'Runde vorbei: {pts} Pkt.',
      'Ball {n} of {total} · {pts} pts': 'Kugel {n} von {total} · {pts} Pkt.',
      'Aim for cup {n} (the gold one).': 'Ziel: Becher {n} (der goldene).',
      'Tap a ramp to turn it, then drop a ball.': 'Tippen Sie auf eine Rampe, um sie zu drehen, und lassen Sie dann eine Kugel fallen.',
      'Rolling…': 'Sie rollt…',
      'Congratulations! Golden cup +5. The start and the golden cup have moved: {aim}': 'Glückwunsch! Goldener Becher: +5. Start und goldener Becher sind umgezogen: {aim}',
      'In cup {n}: +1. {aim}': 'Im Becher {n}: +1. {aim}',
      'That one got stuck. Next ball.': 'Diese Kugel steckt fest. Nächste Kugel!',
      'Round over: {pts} points. Best: {best}. Fancy another round?': 'Runde vorbei: {pts} Punkte. Bestwert: {best}. Noch eine Runde?',
      'START': 'START',
      'Congratulations!': 'Glückwunsch!',
      'Golden cup! +5': 'Goldener Becher! +5'
    },
    es: {
      'Round over: {pts} pts': 'Ronda terminada: {pts} pts',
      'Ball {n} of {total} · {pts} pts': 'Bola {n} de {total} · {pts} pts',
      'Aim for cup {n} (the gold one).': 'Apunte a la copa {n} (la dorada).',
      'Tap a ramp to turn it, then drop a ball.': 'Toque una rampa para girarla y luego suelte una bola.',
      'Rolling…': 'Rodando…',
      'Congratulations! Golden cup +5. The start and the golden cup have moved: {aim}': '¡Felicidades! Copa dorada: +5. La salida y la copa dorada han cambiado de sitio: {aim}',
      'In cup {n}: +1. {aim}': 'En la copa {n}: +1. {aim}',
      'That one got stuck. Next ball.': 'Esa se quedó atascada. Siguiente bola.',
      'Round over: {pts} points. Best: {best}. Fancy another round?': 'Ronda terminada: {pts} puntos. Mejor marca: {best}. ¿Otra ronda?',
      'START': 'SALIDA',
      'Congratulations!': '¡Felicidades!',
      'Golden cup! +5': '¡Copa dorada! +5'
    },
    fr: {
      'Round over: {pts} pts': 'Manche terminée : {pts} pts',
      'Ball {n} of {total} · {pts} pts': 'Bille {n} sur {total} · {pts} pts',
      'Aim for cup {n} (the gold one).': 'Visez la coupe {n} (la dorée).',
      'Tap a ramp to turn it, then drop a ball.': 'Touchez une rampe pour la tourner, puis lâchez une bille.',
      'Rolling…': 'Elle roule…',
      'Congratulations! Golden cup +5. The start and the golden cup have moved: {aim}': 'Bravo ! Coupe dorée : +5. Le départ et la coupe dorée ont changé de place : {aim}',
      'In cup {n}: +1. {aim}': 'Dans la coupe {n} : +1. {aim}',
      'That one got stuck. Next ball.': 'Celle-ci est restée coincée. Bille suivante.',
      'Round over: {pts} points. Best: {best}. Fancy another round?': 'Manche terminée : {pts} points. Record : {best}. Une autre manche ?',
      'START': 'DÉPART',
      'Congratulations!': 'Bravo !',
      'Golden cup! +5': 'Coupe dorée ! +5'
    },
    ar: {
      'Round over: {pts} pts': 'انتهت الجولة: {pts} نقطة',
      'Ball {n} of {total} · {pts} pts': 'الكرة {n} من {total} · {pts} نقطة',
      'Aim for cup {n} (the gold one).': 'صوّب نحو الكوب {n} (الذهبي).',
      'Tap a ramp to turn it, then drop a ball.': 'المس منحدرًا لتديره، ثم أسقط كرة.',
      'Rolling…': 'تتدحرج…',
      'Congratulations! Golden cup +5. The start and the golden cup have moved: {aim}': 'تهانينا! الكوب الذهبي: +5. تغيّر مكان البداية والكوب الذهبي: {aim}',
      'In cup {n}: +1. {aim}': 'في الكوب {n}: +1. {aim}',
      'That one got stuck. Next ball.': 'هذه الكرة علقت. الكرة التالية.',
      'Round over: {pts} points. Best: {best}. Fancy another round?': 'انتهت الجولة: {pts} نقطة. أفضل نتيجة: {best}. جولة أخرى؟',
      'START': 'ابدأ',
      'Congratulations!': 'تهانينا!',
      'Golden cup! +5': 'كوب ذهبي! +5'
    }
  };
  function T(s, v) { var o = (DICT[LANG] || {})[s] || s; if (v) for (var k in v) o = o.split('{' + k + '}').join(v[k]); return o; }

  /* ---------- layout ---------- */
  function makeLayout(narrow) {
    /* one tall board for every screen: more ramps one under the other, so the ball bounces its way down (the `narrow` flag is kept for the tests) */
    var L = { W: 480, H: 740, bins: 4, rows: 7, rowY0: 112, rowGap: 80, divTop: 652 };
    L.binW = L.W / L.bins;
    L.len = Math.round(L.binW * 0.8);
    L.r = 5.5;
    L.ramps = [];
    for (var k = 0; k < L.rows; k++) {
      var y = L.rowY0 + k * L.rowGap;
      var even = k % 2 === 0;
      for (var j = 0; ; j++) {
        var x = L.binW * ((even ? 0.5 : 1.5) + 2 * j);
        if (x + L.len / 2 > L.W + 4) break;
        L.ramps.push({ x: x, y: y, row: k });
      }
    }
    var r0 = L.ramps.filter(function (q) { return q.row === 0; });
    L.feeder = { x: Math.round(r0[Math.floor(r0.length / 2)].x), y: 34 };
    return L;
  }

  /* ramp states: 0 = slopes down to the left, 1 = down to the right, 2 = swung away (ball falls through) */
  var TILT = 0.5; /* radians, about 29 degrees */
  function rampSeg(L, rp, state) {
    if (state === 2) return null;
    var a = state === 0 ? -TILT : TILT, h = L.len / 2;
    var dx = Math.cos(a) * h, dy = Math.sin(a) * h;
    return { x1: rp.x - dx, y1: rp.y - dy, x2: rp.x + dx, y2: rp.y + dy };
  }

  function segments(L, states) {
    var s = [], i;
    for (i = 0; i < L.ramps.length; i++) { var g = rampSeg(L, L.ramps[i], states[i]); if (g) { g.t = 3.2; s.push(g); } }
    for (i = 1; i < L.bins; i++) s.push({ x1: i * L.binW, y1: L.divTop, x2: i * L.binW, y2: L.H, t: 3 });
    return s;
  }

  /* ---------- physics ---------- */
  function newBall(L) { return { x: L.feeder.x, y: L.feeder.y, vx: 0, vy: 0, still: 0, done: false, bin: -1, t: 0 }; }

  function step(L, segs, b, dt) {
    var G = 1100, i, s;
    b.vy += G * dt; b.x += b.vx * dt; b.y += b.vy * dt; b.t += dt;
    if (b.x < L.r) { b.x = L.r; if (b.vx < 0) b.vx *= -0.3; }
    if (b.x > L.W - L.r) { b.x = L.W - L.r; if (b.vx > 0) b.vx *= -0.3; }
    for (i = 0; i < segs.length; i++) {
      s = segs[i];
      var vx = s.x2 - s.x1, vy = s.y2 - s.y1, ll = vx * vx + vy * vy, u = ((b.x - s.x1) * vx + (b.y - s.y1) * vy) / ll;
      u = u < 0 ? 0 : u > 1 ? 1 : u;
      var cx = s.x1 + vx * u, cy = s.y1 + vy * u, dx = b.x - cx, dy = b.y - cy, d = Math.sqrt(dx * dx + dy * dy), min = L.r + s.t;
      if (d < min && d > 1e-6) {
        var nx = dx / d, ny = dy / d, vn = b.vx * nx + b.vy * ny;
        b.x = cx + nx * min; b.y = cy + ny * min;
        if (vn < 0) {
          b.vx -= (1 + 0.42) * vn * nx; b.vy -= (1 + 0.42) * vn * ny;
          var tx = -ny, ty = nx, vt = b.vx * tx + b.vy * ty; /* a little rolling friction */
          b.vx -= vt * 0.012 * tx; b.vy -= vt * 0.012 * ty;
        }
      }
    }
    var sp = Math.sqrt(b.vx * b.vx + b.vy * b.vy);
    if (b.y > L.divTop + 28 && sp < 40) { b.done = true; b.bin = Math.max(0, Math.min(L.bins - 1, Math.floor(b.x / L.binW))); }
    if (b.y > L.H - L.r) { b.y = L.H - L.r; b.vy *= -0.25; b.vx *= 0.9; }
    b.still = sp < 6 ? b.still + dt : 0;
    if (b.still > 1.4 && !b.done) { b.vx += (Math.random() < 0.5 ? -1 : 1) * 160; b.vy -= 160; b.still = 0; } /* never let a ball sit forever */
    if (b.t > 25 && !b.done) { b.done = true; b.bin = -1; }
  }

  /* runs a whole ball with fixed sub-steps; used by the tests */
  function simulate(L, states) {
    var segs = segments(L, states), b = newBall(L), n = 0;
    while (!b.done && n < 60000) { step(L, segs, b, 1 / 240); n++; }
    return b.bin;
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { makeLayout: makeLayout, simulate: simulate, step: step, segments: segments, newBall: newBall }; }
  if (typeof document === 'undefined') return;

  /* ---------- game UI ---------- */
  function init(root) {
    var canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
    var msg = root.querySelector('[data-msg]'), count = root.querySelector('[data-count]'), btnDrop = root.querySelector('[data-drop]'), btnNew = root.querySelector('[data-new]'), box = root.querySelector('[data-box]');
    var L, states, segs, ball = null, gold = 2, round = { n: 0, pts: 0 }, TOTAL = 5, best = 0, scale = 1, dpr = 1, raf = 0, last = 0, fade = null, over = false, narrow = null, petals = [], cheer = null, spots = [60, 180, 300, 420];
    try { best = parseInt(localStorage.getItem('mk-track-best'), 10) || 0; } catch (e) {}

    function setMsg(t) { msg.textContent = t; }
    function status() { count.textContent = over ? T('Round over: {pts} pts', { pts: round.pts }) : T('Ball {n} of {total} · {pts} pts', { n: Math.min(round.n + 1, TOTAL), total: TOTAL, pts: round.pts }); }

    function layout() {
      var w = box.clientWidth || 600, nw = w < 560;
      if (nw !== narrow) {
        narrow = nw; L = makeLayout(nw);
        var keep = states;
        states = L.ramps.map(function (rp, i) { return keep && keep.length === L.ramps.length ? keep[i] : (i % 2); });
        segs = segments(L, states); ball = null; fade = null;
      }
      dpr = Math.min(2, window.devicePixelRatio || 1);
      scale = w / L.W;
      canvas.style.width = w + 'px'; canvas.style.height = Math.round(L.H * scale) + 'px';
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(L.H * scale * dpr);
    }

    function moveTarget() {                       /* new golden cup and a new START spot, never the same as before */
      var g; do { g = Math.floor(Math.random() * L.bins); } while (g === gold && L.bins > 1); gold = g;
      var sx, tries = 0; do { sx = spots[Math.floor(Math.random() * spots.length)]; tries++; } while (sx === L.feeder.x && tries < 20); L.feeder.x = sx;
    }
    function aimMsg(pre) { return (pre ? pre + ' ' : '') + T('Aim for cup {n} (the gold one).', { n: gold + 1 }); }
    function confetti() {
      var cols = ['#ffd1e0', '#ffb3cc', '#fff3f6', '#ffe08a', '#ffffff'], i;
      for (i = 0; i < 46; i++) petals.push({ x: Math.random() * L.W, y: -20 - Math.random() * 160, vx: (Math.random() - .5) * 40, vy: 70 + Math.random() * 90, rot: Math.random() * 6.3, vr: (Math.random() - .5) * 5, s: 6 + Math.random() * 7, c: cols[i % cols.length], ph: Math.random() * 6.3 });
      cheer = { t: 0 };
    }
    function newRound() {
      round = { n: 0, pts: 0 }; over = false; ball = null; fade = null;
      moveTarget(); petals = []; cheer = null;
      btnDrop.disabled = false; btnNew.hidden = true;
      setMsg(aimMsg(T('Tap a ramp to turn it, then drop a ball.'))); status(); draw();
    }

    function drop() {
      if (ball || over) return;
      ball = newBall(L); fade = null; btnDrop.disabled = true; setMsg(T('Rolling…')); status(); loop();
    }

    function finishBall() {
      var pts = ball.bin === gold ? 5 : ball.bin >= 0 ? 1 : 0;
      round.n++; round.pts += pts;
      fade = { x: ball.x, y: ball.y, t: 0 };
      var won = ball.bin === gold;
      if (won) { confetti(); moveTarget(); setMsg(T('Congratulations! Golden cup +5. The start and the golden cup have moved: {aim}', { aim: aimMsg('').trim() })); }
      else setMsg(ball.bin >= 0 ? T('In cup {n}: +1. {aim}', { n: ball.bin + 1, aim: aimMsg('') }) : T('That one got stuck. Next ball.'));
      ball = null;
      if (round.n >= TOTAL) {
        over = true;
        if (round.pts > best) { best = round.pts; try { localStorage.setItem('mk-track-best', String(best)); } catch (e) {} }
        setMsg(T('Round over: {pts} points. Best: {best}. Fancy another round?', { pts: round.pts, best: best }));
        btnNew.hidden = false; btnDrop.disabled = true;
      } else { btnDrop.disabled = false; }
      status();
    }

    function loop(now) {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function (t) {
        var dt = Math.min(0.05, (t - (last || t)) / 1000); last = t;
        if (ball) {
          var n = Math.max(1, Math.ceil(dt / (1 / 240))), k;
          for (k = 0; k < n && ball; k++) { step(L, segs, ball, dt / n); if (ball.done) { finishBall(); } }
        }
        if (fade) { fade.t += dt; if (fade.t > 0.6) fade = null; }
        if (petals.length) { petals.forEach(function (q) { q.ph += dt * 3; q.x += (q.vx + Math.sin(q.ph) * 40) * dt; q.y += q.vy * dt; q.rot += q.vr * dt; }); petals = petals.filter(function (q) { return q.y < L.H + 30; }); }
        if (cheer) { cheer.t += dt; if (cheer.t > 2.6) cheer = null; }
        draw();
        if (ball || fade || petals.length || cheer) loop(); else last = 0;
      });
    }

    function pick(ev) {
      var r = canvas.getBoundingClientRect(), x = (ev.clientX - r.left) / scale, y = (ev.clientY - r.top) / scale, best = -1, bd = 1e9, rad = Math.max(L.len * 0.55, 26 / scale);
      L.ramps.forEach(function (rp, i) { var dx = x - rp.x, dy = y - rp.y, d = Math.sqrt(dx * dx * 0.55 + dy * dy * 1.6); if (d < rad && d < bd) { bd = d; best = i; } });
      return best;
    }
    canvas.addEventListener('pointerdown', function (ev) {
      if (ball) return;
      var i = pick(ev); if (i < 0) return;
      ev.preventDefault();
      states[i] = (states[i] + 1) % 3; segs = segments(L, states); draw();
    });
    btnDrop.addEventListener('click', drop);
    btnNew.addEventListener('click', newRound);
    window.addEventListener('resize', function () { layout(); draw(); });
    if (window.ResizeObserver) new ResizeObserver(function () { layout(); draw(); }).observe(box);

    /* ---------- drawing ---------- */
    function plank(x1, y1, x2, y2, th, wood) {
      var a = Math.atan2(y2 - y1, x2 - x1), len = Math.hypot(x2 - x1, y2 - y1);
      ctx.save(); ctx.translate((x1 + x2) / 2, (y1 + y2) / 2); ctx.rotate(a);
      ctx.fillStyle = 'rgba(0,0,0,.28)'; ctx.fillRect(-len / 2 + 2, th - 1, len, 5);
      var g = ctx.createLinearGradient(0, -th, 0, th); g.addColorStop(0, wood ? '#f0cd91' : '#caa56a'); g.addColorStop(1, wood ? '#cf9c58' : '#a97d44');
      ctx.fillStyle = g; ctx.beginPath(); ctx.roundRect ? ctx.roundRect(-len / 2, -th, len, th * 2, 4) : ctx.rect(-len / 2, -th, len, th * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(120,76,28,.35)'; ctx.lineWidth = 1; for (var i = -1; i <= 1; i += 2) { ctx.beginPath(); ctx.moveTo(-len / 2 + 6, i * th * 0.35); ctx.lineTo(len / 2 - 6, i * th * 0.35); ctx.stroke(); }
      ctx.fillStyle = '#d8b24a'; ctx.beginPath(); ctx.arc(-len / 2 + 7, 0, 2.4, 0, 6.3); ctx.arc(len / 2 - 7, 0, 2.4, 0, 6.3); ctx.fill();
      ctx.restore();
    }

    function ballAt(x, y, a) {
      ctx.save(); ctx.globalAlpha = a == null ? 1 : a;
      ctx.fillStyle = 'rgba(0,0,0,.25)'; ctx.beginPath(); ctx.ellipse(x + 2, y + 6, L.r * 0.9, L.r * 0.4, 0, 0, 6.3); ctx.fill();
      var g = ctx.createRadialGradient(x - L.r * .35, y - L.r * .4, 1, x, y, L.r * 1.1);
      g.addColorStop(0, '#ffffff'); g.addColorStop(.35, '#cfd6dc'); g.addColorStop(1, '#6b7580');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, L.r, 0, 6.3); ctx.fill(); ctx.restore();
    }

    function draw() {
      if (!L) return;
      var i;
      ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);
      /* board */
      var bg = ctx.createLinearGradient(0, 0, 0, L.H); bg.addColorStop(0, '#6f5231'); bg.addColorStop(1, '#4b361e');
      ctx.fillStyle = bg; ctx.fillRect(0, 0, L.W, L.H);
      ctx.strokeStyle = 'rgba(255,220,160,.07)'; ctx.lineWidth = 2;
      for (i = 0; i < L.H; i += 26) { ctx.beginPath(); ctx.moveTo(0, i + (i % 52 ? 5 : 0)); ctx.bezierCurveTo(L.W * .3, i - 6, L.W * .6, i + 8, L.W, i + 2); ctx.stroke(); }
      /* feeder */
      ctx.fillStyle = '#a97d44'; ctx.beginPath(); ctx.moveTo(L.feeder.x - 18, 8); ctx.lineTo(L.feeder.x + 18, 8); ctx.lineTo(L.feeder.x + 8, 28); ctx.lineTo(L.feeder.x - 8, 28); ctx.closePath(); ctx.fill();
      ctx.fillStyle = 'rgba(255,235,190,.8)'; ctx.font = '700 11px system-ui,sans-serif'; var onRight = L.feeder.x > L.W - 110; ctx.textAlign = onRight ? 'right' : 'left'; ctx.fillText(T('START'), onRight ? L.feeder.x - 24 : L.feeder.x + 24, 22);
      /* bins */
      for (i = 0; i < L.bins; i++) {
        var bx = i * L.binW, isG = i === gold;
        var bgc = ctx.createLinearGradient(0, L.divTop, 0, L.H); bgc.addColorStop(0, isG ? '#8a6414' : '#3b2a16'); bgc.addColorStop(1, isG ? '#c9921a' : '#2a1d0e');
        ctx.fillStyle = bgc; ctx.fillRect(bx + 2, L.divTop, L.binW - 4, L.H - L.divTop);
        if (isG) { var gl = ctx.createLinearGradient(0, L.divTop - 60, 0, L.divTop); gl.addColorStop(0, 'rgba(255,205,70,0)'); gl.addColorStop(1, 'rgba(255,205,70,.3)'); ctx.fillStyle = gl; ctx.fillRect(bx + 2, L.divTop - 60, L.binW - 4, 60); }
        ctx.fillStyle = isG ? '#fff2c2' : 'rgba(255,235,200,.6)'; ctx.font = '800 ' + (isG ? 30 : 22) + 'px system-ui,sans-serif'; ctx.textAlign = 'center';
        ctx.fillText(String(i + 1), bx + L.binW / 2, L.H - 14);
        if (isG) { ctx.font = '800 13px system-ui,sans-serif'; ctx.fillStyle = '#ffe9a8'; ctx.fillText('\u2605 +5', bx + L.binW / 2, L.H - 50); }
      }
      for (i = 1; i < L.bins; i++) plank(i * L.binW, L.divTop, i * L.binW, L.H, 3, false);
      /* ramps */
      L.ramps.forEach(function (rp, k) {
        var s = rampSeg(L, rp, states[k]);
        if (s) plank(s.x1, s.y1, s.x2, s.y2, 5.5, true);
        else {
          ctx.setLineDash([4, 5]); ctx.strokeStyle = 'rgba(255,235,190,.35)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(rp.x - L.len / 2, rp.y); ctx.lineTo(rp.x + L.len / 2, rp.y); ctx.stroke(); ctx.setLineDash([]);
        }
        if (!ball && !over) { /* tap hint: tiny pivot dot */ ctx.fillStyle = 'rgba(255,240,200,.55)'; ctx.beginPath(); ctx.arc(rp.x, rp.y, 3, 0, 6.3); ctx.fill(); }
      });
      if (ball) ballAt(ball.x, ball.y);
      if (fade) ballAt(fade.x, fade.y, Math.max(0, 1 - fade.t / 0.6));
      petals.forEach(function (q) {
        ctx.save(); ctx.translate(q.x, q.y); ctx.rotate(q.rot); ctx.fillStyle = q.c; ctx.globalAlpha = .92;
        ctx.beginPath(); ctx.ellipse(0, 0, q.s, q.s * .55, 0, 0, 6.3); ctx.fill(); ctx.restore();
      });
      if (cheer) {
        var a = cheer.t < .25 ? cheer.t / .25 : cheer.t > 2 ? Math.max(0, (2.6 - cheer.t) / .6) : 1;
        ctx.save(); ctx.globalAlpha = a; ctx.textAlign = 'center';
        ctx.fillStyle = 'rgba(30,18,6,.55)'; ctx.fillRect(0, L.H * .36, L.W, 96);
        ctx.fillStyle = '#ffe28a'; ctx.font = '800 38px system-ui,sans-serif'; ctx.fillText(T('Congratulations!'), L.W / 2, L.H * .36 + 46);
        ctx.fillStyle = '#fff6dc'; ctx.font = '700 17px system-ui,sans-serif'; ctx.fillText(T('Golden cup! +5'), L.W / 2, L.H * .36 + 76);
        ctx.restore();
      }
    }

    layout(); newRound();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-play-track]'), function (el) { if (!el.__mt) { el.__mt = 1; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
